import CreateRetailer from './CreateRetailer'
import {connect, actions} from '../../../stores'

const mapDispatchToProps = dispatch => ({
  hydrateCurrentUser: payload => dispatch(actions.auth.hydrateCurrentUser(payload)),
  manuallySetJWTFromCookie: payload => dispatch(actions.auth.manuallySetJWTFromCookie(payload)),
});

const ConnectedCreateRetailer= connect(null, mapDispatchToProps)(CreateRetailer);

export default ConnectedCreateRetailer